import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import { DoctrineUnloggedLock_OfferLockDataFragment } from './__generated__/doctrine-unlogged-lock.graphql'
import styles from './doctrine-unlogged-lock.module.scss'
import { DoctrineUnloggedLockContent } from './doctrine-unlogged-lock-content'

export interface DoctrineUnloggedLockProps {
  offerLockData: DoctrineUnloggedLock_OfferLockDataFragment
}

export function DoctrineUnloggedLock({ offerLockData }: DoctrineUnloggedLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = <DoctrineUnloggedLockContent offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles['paywall-doctrine-lock']}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return (
        <ModalLock size="sm" offerLockBody={offerLockData.body}>
          {content}
        </ModalLock>
      )
    default:
      return null
  }
}

DoctrineUnloggedLock.fragments = {
  offerLockData: gql`
    fragment DoctrineUnloggedLock_offerLockData on OfferLockData {
      ...DoctrineUnloggedLockContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${DoctrineUnloggedLockContent.fragments.offerLockData}
  `,
}
